import {DatevWizardCaseSelectionState} from './datev-wizard-case-selection.state';

/**
 * Initial State für DatevWizardCaseSelection
 *
 * Noch keine Fallauswahl getroffen (selectedCase = undefined)
 */
export const datevWizardCaseSelectionStateInitial: DatevWizardCaseSelectionState = {
  selectedCase: undefined,
};
